export const socialsData = {
    github: 'https://github.com/kelebetengida',
    linkedIn: 'https://www.linkedin.com/in/kelebet-engida-5825a8160/',
    instagram: 'https://www.instagram.com/kelebetphotography/',
    blogger: 'https://codeandcuriosity.blogspot.com/'
}